import React, { useState } from 'react';
import { Shield, Check, X, AlertCircle, Loader2, ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '../ui/button';

export function JudgeStatus({ analysis, onJudge, judging }) {
  const judge = analysis.judge;
  const [collapsed, setCollapsed] = useState(false);

  if (!analysis.optimization && !judge) return null;

  return (
    <div className="msml-slide-up" style={{ animationDelay: '0.25s' }}>
      {analysis.optimization && !judge && (
        <Button onClick={onJudge} disabled={judging} className="msml-btn-secondary w-full" data-testid="judge-btn">
          {judging ? (
            <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Verifying intent &amp; safety...</>
          ) : (
            <><Shield className="w-4 h-4 mr-2" />Verify with Judge</>
          )}
        </Button>
      )}

      {judge && (
        <div className="msml-card !p-3 !gap-2" data-testid="verdict-card">
          <button
            onClick={() => setCollapsed(!collapsed)}
            className="flex items-center justify-between w-full text-left"
            data-testid="judge-toggle"
          >
            <div className="flex items-center gap-2">
              <span className="msml-label text-[10px] !mb-0">Judge Verdict</span>
              <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium ${
                judge.verdict === 'APPROVED'    ? 'bg-[var(--msml-success)]/15 text-[var(--msml-success)]' :
                judge.verdict === 'REJECTED'    ? 'bg-[var(--msml-danger)]/15 text-[var(--msml-danger)]' :
                                                  'bg-[var(--msml-warning)]/15 text-[var(--msml-warning)]'
              }`} data-testid="verdict-badge">
                {judge.verdict === 'APPROVED' && <Check className="w-2.5 h-2.5" />}
                {judge.verdict === 'REJECTED' && <X className="w-2.5 h-2.5" />}
                {judge.verdict === 'NEEDS_REVIEW' && <AlertCircle className="w-2.5 h-2.5" />}
                {judge.verdict}
              </span>
            </div>
            {collapsed ? <ChevronDown className="w-3.5 h-3.5 text-[var(--msml-text-muted)]" /> : <ChevronUp className="w-3.5 h-3.5 text-[var(--msml-text-muted)]" />}
          </button>

          {!collapsed && (
            <div className="space-y-2 pt-1.5">
              <div className="space-y-1.5">
                <VerdictRow label="Intent Preserved" passed={judge.intentStatus === 'pass'} detail={`Similarity: ${Math.round((judge.intentSimilarity || 0) * 100)}%`} />
                <VerdictRow label="Safety Check" passed={judge.safetyStatus === 'pass'} detail={judge.safetyStatus} />
                <VerdictRow label="Dependency Check" passed={!judge.dependencyIncrease} detail={judge.dependencyIncrease ? 'Increased' : 'No increase'} />
              </div>
              {judge.notes && (
                <p className="text-[10px] text-[var(--msml-text-muted)] pt-1.5 border-t border-white/5 leading-relaxed">
                  {judge.notes}
                </p>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function VerdictRow({ label, passed, detail }) {
  return (
    <div className="flex items-start gap-2">
      {passed
        ? <Check className="w-3 h-3 text-[var(--msml-success)] mt-0.5 flex-shrink-0" />
        : <X className="w-3 h-3 text-[var(--msml-danger)] mt-0.5 flex-shrink-0" />
      }
      <div>
        <p className="text-[11px] text-white">{label}</p>
        {detail && <p className="text-[9px] text-[var(--msml-text-muted)]">{detail}</p>}
      </div>
    </div>
  );
}
